exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookies-banner{position:fixed;z-index:1000;bottom:0;right:0;left:0;padding:4rem;background-color:#2a2a2a;color:#f4f4f4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26281bf2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/shared/CookiesBanner.vue
// module id = 319
// module chunks = 34